export var QueryDBStatus;
(function (QueryDBStatus) {
    QueryDBStatus["QUERY_STATUS_UNSPECIFIED"] = "UNSPECIFIED";
    QueryDBStatus["QUERY_IN_PROGRESS"] = "IN_PROGRESS";
    QueryDBStatus["QUERY_COMPLETED"] = "COMPLETED";
    QueryDBStatus["QUERY_CANCELED"] = "CANCELED";
    QueryDBStatus["QUERY_FAILED"] = "FAILED";
})(QueryDBStatus || (QueryDBStatus = {}));
